<template>
    <div class="variable-helper">
        <div class="d-flex align-items-baseline mb-2">
            <h6 class="mb-0 mr-2">사용 가능한 변수</h6>
            <small class="text-muted">{{ totalCount }}개</small>
        </div>
        <p class="small text-muted mb-2">
            <b>삽입</b> 버튼 클릭 시 커서 위치에 자동 삽입됩니다.
        </p>
        <b-form-input
            v-model="search"
            size="sm"
            class="mb-2"
            placeholder="변수 검색…"
        />
        <div v-if="error && (!variables || !variables.length)" class="text-danger small">
            변수 정보를 불러오지 못했습니다.
            <b-link @click="$emit('retry')">다시 시도</b-link>
        </div>
        <div v-else-if="!variables || !variables.length" class="text-muted small">
            변수 정보를 불러오는 중...
        </div>
        <div v-for="group in filteredGroups" :key="group.key" class="mb-2">
            <div
                class="d-flex align-items-center cursor-pointer py-1"
                @click="toggle(group.key)"
            >
                <AppIcon :name="isExpanded(group.key) ? 'chevron-down' : 'chevron-right'" class="mr-1 small"/>
                <strong class="small">{{ group.label }}</strong>
                <small class="text-muted ml-2">{{ group.key }} · {{ group.fields.length }}</small>
            </div>
            <div v-if="isExpanded(group.key)" class="pl-3">
                <div
                    v-for="field in group.fields"
                    :key="field"
                    class="d-flex align-items-center py-1"
                >
                    <code class="small flex-grow-1 text-dark">{{ group.key }}.{{ field }}</code>
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        class="py-0 px-1 ml-1"
                        style="font-size: 11px; line-height: 1.4;"
                        @click="$emit('insert', group.key, field)"
                    >삽입</b-button>
                </div>
            </div>
        </div>
        <div v-if="filteredGroups.length === 0 && variables && variables.length" class="text-muted small text-center py-3">
            검색 결과가 없습니다.
        </div>
    </div>
</template>

<script>
import { HIDDEN_VARIABLE_FIELDS } from '../data'

export default {
    name: 'VariableHelper',
    props: {
        error: {
            type: Boolean,
            default: false,
        },
        variables: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            expanded: {},
            search: '',
        }
    },
    computed: {
        // 시스템/보안 필드를 제외하고 표시할 그룹 목록
        visibleGroups() {
            return (this.variables || []).map(g => ({
                ...g,
                fields: (g.fields || []).filter(f => !HIDDEN_VARIABLE_FIELDS.has(`${g.key}.${f}`)),
            })).filter(g => g.fields.length > 0)
        },
        // 검색어 적용 후 표시 그룹
        filteredGroups() {
            const q = this.search.trim().toLowerCase()
            if (!q) return this.visibleGroups
            return this.visibleGroups.map(g => ({
                ...g,
                fields: g.fields.filter(f =>
                    `${g.key}.${f}`.toLowerCase().includes(q)
                    || (g.label || '').toLowerCase().includes(q)
                ),
            })).filter(g => g.fields.length > 0)
        },
        totalCount() {
            return this.visibleGroups.reduce((sum, g) => sum + g.fields.length, 0)
        },
    },
    methods: {
        toggle(key) {
            this.$set(this.expanded, key, !this.expanded[key])
        },
        isExpanded(key) {
            // 검색어가 있으면 모두 펼침, 없으면 사용자 토글 상태
            return this.search.trim() ? true : !!this.expanded[key]
        },
    },
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.variable-helper {
    max-height: 500px;
    overflow-y: auto;
}
</style>
